import React from 'react';
import { reduxForm, Field, FieldArray } from "redux-form";
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import config from "config";

import { TextInput } from '../TextInput';
import { RadioInput } from '../RadioInput';
import { SelectInput } from '../SelectInput';
import { CheckboxInput } from "../CheckboxInput";
import { DeviceDataClassificationsService, TagsService } from "../../services";

const validate = (values) => {
  const errors = {};
  
  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-asset-type-name');
  }

  if (values.measures) {
    var measureArrayErrors = [];
    values.measures.forEach((measure, index) => {
      if (!measure.name) {
          measureArrayErrors[index] = { name: i18next.t("messages.please-enter-asset-measure-name") };
      }
      if (!measure.measureType) {
          measureArrayErrors[index] = { name: i18next.t("messages.please-select-asset-measure-type") };
      }
    });
    if (measureArrayErrors.length) {
      errors.measures = measureArrayErrors;
    }
  }

  if (values.assetTypeMetadataTypes) {
    var metadataTypeArrayErrors = []
    values.assetTypeMetadataTypes.forEach((metadataType, index) => {
      if(!metadataType.name) {
        metadataTypeArrayErrors[index] = {'name': i18next.t('messages.please-enter-asset-metadata-type-name')};
      }
    });
    if (metadataTypeArrayErrors.length) {
      errors.assetTypeMetadataTypes = metadataTypeArrayErrors
    }
  }

  return errors;
};

class AssetTypeForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      availableAssetTypeMetadataTypes: null,
      availableGenericTags: null,
      availableAreaTags: null,
      measureOptions: null
    }

    if (props.assetType) {
      let initData = {
        name: props.assetType.name,
        requiresFloorplan: true,
        assetTypeMetadataTypes: null,
        defaultTags: null,
        defaultAreaTag: null,
        measures: null,
      }

      if (props.assetType.assetTypeMetadataTypes) {
        initData.assetTypeMetadataTypes = props.assetType.assetTypeMetadataTypes.map((metadataType) => ({
          name: metadataType.name,
          valueType: metadataType.stringValueFlag ? 'string' : 'numeric',
          metadataType: metadataType
        }));
      }

      if (props.assetType.measures) {
        initData.measures = props.assetType.measures.map((measure) => ({
          name: measure.name,
          displayOrder: measure.displayOrder,
          measureType: { value: measure.deviceDataClassification.id, label: measure.deviceDataClassification.name, deviceDataClassification: measure.deviceDataClassification },
          measure: measure
        }));
      }

      if (props.assetType.defaultTags) {
        initData.defaultTags = props.assetType.defaultTags.filter((tag) => tag.tagType.token == "area").map((tag) => ({value: tag.id, label: tag.name, tag: tag}));
        initData.defaultAreaTag = props.assetType.defaultTags.filter((tag) => tag.tagType.token != "area").map((tag) => ({value: tag.id, label: tag.name, tag: tag}));
      }
      
      this.props.initialize(initData);
    } else {
      this.props.initialize({
        requiresFloorplan: true
      });
    }
  }

  componentDidMount() {
    DeviceDataClassificationsService.listAll().then((response) => {
      this.setState({ 
        measureOptions: response.deviceDataClassifications.map(deviceDataClassification => ({ value: deviceDataClassification.id, label: deviceDataClassification.name, deviceDataClassification: deviceDataClassification })) 
      });
    }).catch((error) => {
      console.log(error);
    });

    TagsService.listAll().then((response) => {
      this.setState({ 
        availableGenericTags: response.tags.filter(tag => tag.tagType.token === 'generic').map(tag => ({ value: tag.id, label: tag.name })),
        availableAreaTags: response.tags.filter(tag => tag.tagType.token === 'area').map(tag => ({ value: tag.id, label: tag.name })) 
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    const { handleSubmit, invalid, submitting } = this.props;
    // const tagName = this.props.form.TagForm.values && this.props.form.TagForm.values.name ? this.props.form.TagForm.values.name : this.props.tag.name;

    if (this.state.availableGenericTags && this.state.measureOptions) {
      return (
        <div className="login-form tag-form op-content-box">
          <form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} sm={6}>
                <div className="form-tag">
                  <Field name="name" type="text" component={TextInput} label={i18next.t('form-labels.name')} />
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className="form-tag" style={{paddingTop: 20}}>
                  <Field name="requiresFloorplan" className="inline" type="checkbox" component={CheckboxInput} label={i18next.t('form-labels.requires-floorplan')} />
                </div>
              </Col>              
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <div className="form-tag">
                    <label>{i18next.t('pages.asset-types.default-tags')}</label>
                    <Field name="defaultTags" options={this.state.availableGenericTags} component={SelectInput} isMulti />
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className="form-tag">
                    <label>{i18next.t('pages.asset-types.default-area')}</label>
                    <Field name="defaultAreaTag" options={this.state.availableAreaTags} component={SelectInput} />
                </div>
              </Col>
            </Row>

            <br />

            <Row>
              <Col xs={12} sm={12}>
                <div className="form-tag">
                    <label>{i18next.t('pages.asset-types.allowed-measures')}</label>
                    <FieldArray name='measures' component={AssetTypeMeasures} measureOptions={this.state.measureOptions} />
                </div>
              </Col>
            </Row>

            <br />

            <Row>
              <Col xs={12} sm={12}>
                <div className="form-tag">
                  <label>{i18next.t('pages.asset-types.metadata-types')}</label>
                  <FieldArray name='assetTypeMetadataTypes' component={AssetTypeMetadataTypes} />
                </div>
              </Col>
            </Row>
            
            { this.props.onDelete && 
              <div className="pull-right tooltip" style={{paddingTop: 20}}>
                <img style={{paddingRight: 15}} className="tag-form-delete-button" src={`${config.WEB_BASE_URL}/images/icon/delete-trash-can.svg`} onClick={this.props.onDelete}/>
                <span className="tooltiptext">{i18next.t('delete')}</span>
              </div>
            }

            <ul style = {{paddingTop: 20}} className="list-inline clearfix">
              <li><button type="submit" className="btn btn-primary" disabled={invalid || submitting}>{i18next.t('form-labels.save')}</button></li>
              <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/admin/asset-types`}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link></li>
            </ul>
          </form>
        </div>
      );
    } else {
      return (
            <div className="loader">{i18next.t('loading')}</div>
        );
    }
  }
}

const AssetTypeMeasures = ({ fields, measureOptions }) => (
  <div>
    <table className='table'>
      <thead>
        <tr>
          <th style={{width: '60%'}}>{i18next.t('pages.asset-types.name')}</th>
          <th style={{width: '30%'}}>{i18next.t('pages.asset-types.measure')}</th>
          <th style={{width: '10%'}}>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
      {
        fields.length == 0 ? (<AssetTypeMeasuresEmptyRow />) :
        fields.map((measure, index) => (
          <AssetTypeMeasureRow measure={measure} measureOptions={measureOptions} fields={fields} index={index} key={index} />
        ))
      }
        <AssetTypeMeasuresAddRow fields={fields} />
      </tbody>
    </table>
  </div>
);

const AssetTypeMeasuresEmptyRow = () => (
  <tr>
    <td colSpan={3} style={{textAlign: 'center'}}>
      {i18next.t('pages.asset-types.no-measures')}
    </td>
  </tr>
);

const AssetTypeMeasuresAddRow = ({ fields }) => (
  <tr>
    <td colSpan={3} style={{textAlign: 'center'}}>
      <button className="btn btn-default btn-sm" type="button" onClick={() => fields.push({name:'', measureType:null, displayOrder:fields.length})}>{i18next.t('pages.asset-types.add')}</button>
    </td>
  </tr>
);

const AssetTypeMeasureRow = ({ fields, measure, measureOptions, index }) => (
  <tr>
    <td>
      <div className="form-tag">
        <Field name={`${measure}.name`} type="text" component={TextInput} />
      </div>
    </td>
    <td>
      <div className="form-tag">
        <Field name={`${measure}.measureType`} options={measureOptions} component={SelectInput} />
      </div>
    </td>
    <td>
      <div className="form-tag">
        <button className="btn btn-default btn-sm" type="button" onClick={() => fields.remove(index)}>{i18next.t('pages.asset-types.remove')}</button>
      </div>
    </td>
  </tr>
);

const AssetTypeMetadataTypes = ({ fields }) => (
  <div>
    <table className='table'>
      <thead>
        <tr>
          <th style={{width: '60%'}}>{i18next.t('pages.asset-types.name')}</th>
          <th style={{width: '30%'}}>{i18next.t('pages.asset-types.value-type')}</th>
          <th style={{width: '10%'}}>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
      {
        fields.length == 0 ? (<AssetTypeMetadataTypeEmptyRow />) :
        fields.map((metadataType, index) => (
          <AssetTypeMetadataTypeRow metadataType={metadataType} fields={fields} index={index} key={index} />
        ))
      }
        <AssetTypeMetadataTypeAddRow fields={fields} />
      </tbody>
    </table>
  </div>
);

const AssetTypeMetadataTypeEmptyRow = () => (
  <tr>
    <td colSpan={3} style={{textAlign: 'center'}}>
      {i18next.t('pages.asset-types.no-metadata-types')}
    </td>
  </tr>
);

const AssetTypeMetadataTypeAddRow = ({ fields }) => (
  <tr>
    <td colSpan={3} style={{textAlign: 'center'}}>
      <button className="btn btn-default btn-sm" type="button" onClick={() => fields.push({name:'', valueType:'string'})}>{i18next.t('pages.asset-types.add')}</button>
    </td>
  </tr>
);

const AssetTypeMetadataTypeRow = ({ fields, metadataType, index }) => (
  <tr>
    <td>
      <div className="form-tag">
        <Field name={`${metadataType}.name`} type="text" component={TextInput} />
      </div>
    </td>
    <td>
      <div className="form-tag">
        <Field name={`${metadataType}.valueType`} component={RadioInput} type="radio" value="string" checked={true} label={` ${i18next.t('pages.asset-types.string')}`} />
        <Field name={`${metadataType}.valueType`} component={RadioInput} type="radio" value="numeric" label={` ${i18next.t('pages.asset-types.numeric')}`} />
      </div>
    </td>
    <td>
      <div className="form-tag">
        <button className="btn btn-default btn-sm" type="button" onClick={() => fields.remove(index)}>{i18next.t('pages.asset-types.remove')}</button>
      </div>
    </td>
  </tr>
);

export default reduxForm({ form: 'AssetTypeForm', validate })(connect((state) => ({ form: state.form }))(AssetTypeForm));
